import { Navigate, RouteObject, useRouteError } from 'react-router-dom';
import { RegionEnum } from '~/api/types';
import { Layout } from '~/components';
import { AuthError } from '~/libs/errors/auth';
import {
  DataCatalogPage,
  DatasetDetailsPage,
  GenericError,
  IconsPage,
  LogoutPage,
  NoPageFound,
  ProjectDetailsPage,
  ProjectsPage,
  StoragePage,
} from '~/pages';
import { AdminSettingsPage } from './pages/AdminSettingsPage';
import { AuthErrorModal } from './pages/Auth';

const ErrorBoundary = () => {
  const error = useRouteError();

  console.error('error: ', error);

  if (error instanceof AuthError) return <AuthErrorModal message={error.message} status={error.status} />;

  return (
    <Layout>
      <GenericError error={error} />
    </Layout>
  );
};

export const getRouterBasename = () => {
  const [, maybeRegion] = window.location.pathname.split('/');

  return Object.values(RegionEnum).includes(maybeRegion as RegionEnum) ? `/${maybeRegion}` : '/';
};

type SignOut = (() => void | Promise<void>) | undefined;

const createRoutes = (signOut: SignOut): RouteObject[] => [
  {
    Component: Layout,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/',
        element: <Navigate to="projects" replace />,
      },
      {
        path: 'projects',
        Component: ProjectsPage,
      },
      {
        path: 'settings',
        Component: AdminSettingsPage,
      },
      {
        path: 'projects/:projectid',
        Component: ProjectDetailsPage,
      },
      {
        path: 'data-catalog',
        Component: DataCatalogPage,
      },
      {
        path: 'data-catalog/:id',
        Component: DatasetDetailsPage,
      },
      {
        path: 'storage',
        Component: StoragePage,
      },
      // page for icons, only for development/demo purposes
      {
        path: 'icons',
        Component: IconsPage,
      },
      {
        path: 'logout',
        element: <LogoutPage signOut={signOut} />,
      },
      {
        path: '*',
        Component: NoPageFound,
      },
    ],
  },
];

export default createRoutes;
